import * as stylex from '@stylexjs/stylex'
import { type ComponentPropsWithoutRef } from 'react'

const baseStyles = stylex.create({
  root: {
    alignItems: 'center',
    boxSizing: 'border-box',
    cursor: 'inherit',
    display: 'inline-flex',
    fontSize: 20,
    justifyContent: 'center',
  },
})

export interface ButtonIconProps extends ComponentPropsWithoutRef<'div'> {
  rootStyle?: stylex.StyleXStyles
}

export const ButtonIcon = (props: ButtonIconProps) => {
  const { rootStyle, children, ...rest } = props
  return (
    <div {...stylex.props(baseStyles.root, rootStyle)} {...rest}>
      {children}
    </div>
  )
}
